module.exports = __webpack_public_path__ + "img/xero.0f43782f.png";